import React from 'react';

import { DesignBlockMenuItem } from '../Components/DesignBlockMenuItem';

export const TemplateStudioPopupForm: React.FC = () => {
  return (
    <DesignBlockMenuItem
      className="design-block-menu-item"
      blockType={'popup'}
    />
  );
};
